import { useState, useEffect } from 'react';
import { i18nAPI } from '../services/api';

/**
 * Detects whether the currently logged-in user has the TRANSLATOR role.
 *
 * Fetches GET /api/i18n/me once on mount (only if a token is present in
 * localStorage). Failures are silenced — translator mode is purely additive
 * and must never break the normal consumer experience.
 *
 * @returns {{ isTranslator: boolean, userLocale: string|null }}
 */
export function useTranslatorMode() {
  const [isTranslator, setIsTranslator] = useState(false);
  const [userLocale, setUserLocale] = useState(null);

  useEffect(() => {
    // Support all token key names used across the frontend
    const token =
      localStorage.getItem('venue_app_token') ||
      localStorage.getItem('token') ||
      localStorage.getItem('authToken') ||
      localStorage.getItem('agentToken');

    if (!token) return;

    i18nAPI
      .getMe()
      .then((res) => {
        const user = res.data?.user;
        if (user?.role === 'TRANSLATOR') {
          setIsTranslator(true);
          setUserLocale(user.preferred_locale || null);
        }
      })
      .catch(() => {
        // Silently swallow — translator mode is optional and must not
        // surface errors to regular consumers.
      });
  }, []);

  return { isTranslator, userLocale };
}
